'use client'
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2'
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/Carousel';

import React from 'react'
import Image from 'next/image';
import ImageLoading from '@/components/ImageLoading';

export default function TopSights() {
    const { topAttractions, itinerary, } = useItineraryStoreV2()

    return topAttractions.length > 0 && (
        <div className=''>
            <p className='mb-4 text-2xl font-bold pl-4'> Top Sights in {itinerary?.city} </p>
            <Carousel className="w-full ">
                <CarouselContent className=''>
                    {topAttractions.map(item =>
                        <div className='first:ml-8 mr-4 relative group' key={item.attractionId}>
                            <div className='w-[208px] relative z-0  h-[212px] rounded-2xl overflow-hidden '>
                                <ImageLoading className='group-hover:scale-105 transition-transform duration-300
                                     w-full h-full'
                                    src={item.image}
                                    width={250}
                                    height={250}
                                    alt={item.name} />
                            </div>
                            <div className='flex flex-col absolute bottom-2 left-2'>
                                <span className='bg-black/50 px-2 py-1 line-clamp-1 max-w-[85%] rounded-lg text-white text-xs capitalize'>{item.name}</span>
                            </div>

                        </div>)}

                </CarouselContent>
                <CarouselPrevious className='left-2 cursor-pointer size-9' />
                <CarouselNext className='right-2 cursor-pointer size-9' />
            </Carousel>
        </div>
    )
}
